import React from "react";
import { Header } from "@tvg/design-system/web";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import { HeaderContainer, HeaderWrapper } from "./styled-components";

export interface ContentTitleProps {
  content: {
    bloks: {
      _uid: string;
      header: string;
      component: string;
      _editable?: string;
    }[];
  };
}

const ContentTitle: React.FC<ContentTitleProps> = ({ content }) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const header = content.bloks?.[0]?.header?.trim();

  if (!header) return null;

  return (
    <HeaderContainer>
      <HeaderWrapper isMobile={isMobile}>
        <Header
          tag="h2"
          lineHeight="var(--fd-line-heights-line-height-030)"
          color="--fd-colors-content-strong"
          fontFamily="bold"
        >
          {header}
        </Header>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default ContentTitle;
